import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  f7,
  Page,
  Link,
  Button,
  Input,
  ListItem,
  Icon,
  Popup,
  List,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, FUTURE_DATE } from "./../globals";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import "./DatePicker.css";
import debounce from "lodash.debounce";

const EditEventPage = ({ f7route }) => {
  const { id } = f7route.params;
  // const [event_name, setEventName] = useState('');
  // const [event_date, setEventDateTime] = useState('');
  // const [event_adult_size, setNoAdults] = useState('');
  // const [event_kids_size, setNoKids] = useState('');
  // const [event_address, setAddress] = useState('');
  // const [event_address_two, setAddressTwo] = useState('');
  // const [event_city, setCity] = useState('');
  // const [event_state, setState] = useState('');
  // const [event_zip, setZip] = useState('');

  // const cust_id = localStorage.getItem('id');
  // const issetpayment = '0';
  const [selectedDate, setSelectedDate] = useState(null);
  const [citydata, setCityData] = useState([]);
  const formRef = useRef(null);
  const [restdata, setRestDetails] = useState([]);
  const [edit_rest, setEditRest] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    cust_id: localStorage.getItem("id"),
    order_status: 1,
    edit_rest_id: [],
  });
  const [bidRequestDate, setBidRequestDate] = useState(null);
  const [menuType, setMenuType] = useState([]);
  const [menuTypeId, setMenuTypeId] = useState(0);
  const [stateId, setStateId] = useState(0);
  const [cuisineType, setCuisineType] = useState([]);
  const [cuisine, setCuisine] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState();
  const [addressInfo, setAddressInfo] = useState();
  const [addressSuggestions, setAddressSuggestions] = useState([]);

  useEffect(() => {
    // get event data
    axios
      .get(API_BASE_URL + "event", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          id: id,
        },
      })
      .then((response) => {
        setFormData(response.data.data[0]);
        setAddressInfo({
          add_lin_1: response.data.data[0].add_lin_1,
          add_lin_2: response.data.data[0].add_lin_2,
          city: response.data.data[0].city,
          state: response.data.data[0].state,
          zip_code: response?.data.data[0]?.zip_code?.replace(/\s+$/, ""),
          event_note: response.data.data[0].event_note,
        });
        setEditRest(response.data.data[0].restaurant.map((item) => item.id));
        setSelectedDate(moment(response.data.data[0].edit_event_date).toDate());
        setBidRequestDate(
          moment(response.data.data[0].edit_bid_end_date).toDate()
        );
        setData(response.data.data[0].item);
        setRestItem(response.data.data[0].rest_item);
        setStateId(response.data.data[0].state_id);
        localStorage.setItem(
          "cartItems",
          JSON.stringify(response.data.data[0].item)
        );
        setSelectedRadio(
          response.data.data[0].delivery_type == "1" ? "1" : "2"
        );
        // console.log(
        //   "response.data.data[0]",
        //   response.data.data[0].delivery_type
        // );
      })
      .catch((error) => console.log(error));

    // get state
    axios
      .get(API_BASE_URL + "state", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setCityData(response.data))
      .catch((error) => console.log(error));
    axios
      .get(API_BASE_URL + "menutype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setMenuType(response.data.data))
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "cuisintype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setCuisine(response.data);
      })
      .catch((error) => console.log(error));
  }, [id]);

  const [product, setProduct] = useState({
    menu_name: "",
    note: "",
  });

  // get rest
  useEffect(() => {
    // eventbycust/id/+ localStorage.getItem('id') +/?event_id=188
    axios
      .get(API_BASE_URL + "restaurants", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cuisine_type: cuisineType,
        },
      })
      .then((response) => setRestDetails(response.data))
      .catch((error) => console.log(error));
  }, [cuisineType]);

  // console.log(restdata);

  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const options = ["Apple", "Banana", "Cherry", "Grape", "Lemon", "Orange"];
  const handleOptionClick = (option) => {
    setInputValue(option);
    setFilteredOptions([]);
  };
  const handleRadioChange = (value) => {
    setSelectedRadio(value);
  };
  const handleInputChange = (event) => {
    // const value = event.target.value;
    // setInputValue(value);

    // const filtered = options.filter((option) =>
    //   option.toLowerCase().includes(value.toLowerCase())
    // );
    // setFilteredOptions(filtered);

    const { name, value } = event.target;
    setProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  const [data, setData] = useState([]);
  const [restItem, setRestItem] = useState([]);

  useEffect(() => {
    localStorage.removeItem("cartItems");
    const storedData = JSON.parse(localStorage.getItem("cartItems")) || [];
    setData(storedData);
    setFormData({
      ...formData,
      items: JSON.parse(localStorage.getItem("cartItems")),
    });
  }, []);

  // const handleSubmit = async (e) => {
  const handleAddToCart = async (e) => {
    e.preventDefault();
    // Validate the product object and add it to the cart
    if (searchTerm) {
      const newproduct = {
        menu_name: searchTerm,
        note: product.note,
      };

      const newItem = { ...newproduct };

      // Retrieve existing cart items from localStorage
      const existingItems = localStorage.getItem("cartItems");
      let cartItems = existingItems ? JSON.parse(existingItems) : [];

      // Add the new item to the cart
      cartItems.push(newItem);
      // Save the updated cart items to localStorage
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      const storedData = JSON.parse(localStorage.getItem("cartItems")) || [];
      setData(storedData);

      //   useEffect(() => {
      //     const storedData = JSON.parse(localStorage.getItem('cartItems')) || [];
      //     setData(storedData);
      //   }, []);
      setFormData({
        ...formData,
        items: JSON.parse(localStorage.getItem("cartItems")),
      });

      const inputMenu = document.getElementById("inputMenu");
      const inputNote = document.getElementById("inputNote");

      console.log(inputMenu);
      if (inputMenu) {
        inputMenu.value = "";
      }
      if (inputNote) {
        inputNote.value = "";
      }

      f7.popup.close(".demo-popup");
      formRef.current.reset();
      setSearchTerm("");
    } else {
      alert("Please select all options.");
      setSearchTerm("");
    }
  };

  // Delete
  const handleDelete = (index) => {
    const updatedProduct = [...data];
    var prodArray = updatedProduct[index];
    updatedProduct.splice(index, 1);
    if (prodArray && prodArray.id !== undefined) {
      axios
        .delete(API_BASE_URL + "deleteeventitem/id/" + prodArray.id, {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        })
        .then((response) => {
          f7.toast
            .create({
              text: "Item deleted..!",
              position: "top",
              cssClass: "bg-color-teal",
              closeTimeout: 3000,
            })
            .open();
        })
        .catch((error) => console.log(error));
      // f7.views.main.router.back({ force: true });
      // f7.tab.show('#tab-3');
    }
    setData(updatedProduct);
    localStorage.setItem("cartItems", JSON.stringify(updatedProduct));
    setFormData({
      ...formData,
      items: JSON.parse(localStorage.getItem("cartItems")),
    });
  };

  const handleSelectChange = (event) => {
    const options = event.target.selectedOptions;
    const values = Array.from(options).map((option) => option.value);
    setEditRest(values);
    setFormData((prevValues) => ({
      ...prevValues,
      rest_id: values,
    }));
    console.log(formData);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      add_lin_1: value,
    });
    // setAddressSearchTerm(value);
    debouncedFetchAddresses(value);
  };

  const debouncedFetchAddresses = useCallback(
    debounce((value) => {
      if (value.length > 0) {
        axios
          .get(API_BASE_URL + `googleapiaddresssearch/?input=${value}`, {
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          })
          .then((response) => {
            // const formattedAddress = response?.data?.data?.map(
            //   (add) => add?.formatted_address
            // );

            setAddressSuggestions(response?.data?.data?.predictions);
          })
          .catch((error) => {
            console.log(error);
            setAddressSuggestions([]);
          });
      } else {
        setAddressSuggestions([]);
      }
    }, 500),
    []
  );

  const handleAddressItemClick = async (item) => {
    setAddressSuggestions("");
    // setFormData({
    //   ...formData,
    //   add_lin_1: item.formatted_address,
    // });
    // setAddressSearchTerm(item.formatted_address);
    setAddressSuggestions("");
    await axios
      .get(API_BASE_URL + `googleapiplaceidsearch/?place_id=${item.place_id}`, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        let formattedData = JSON.parse(response.data.data);

        const addressComponents = formattedData?.address_components || [];
        const updatedFormData = {
          add_lin_1: formattedData?.formatted_address1,
          add_lin_2: "",
          city: "",
          // state: "",
          zip_code: "",
        };
        // setFormData({
        //   ...formData,
        //   add_lin_1: item.formatted_address,
        // });
        addressComponents.forEach((component) => {
          switch (component.types[0]) {
            case "locality":
              updatedFormData.city = component?.long_name;
              break;
            case "sublocality_level_1":
              updatedFormData.add_lin_2 = component?.long_name;
              break;
            case "postal_code":
              updatedFormData.zip_code = component?.long_name;
              break;
            case "administrative_area_level_1":
              const matchingState = citydata.find(
                (item) => item.name === component?.long_name
              );
              if (matchingState) {
                // updatedFormData.state = matchingState?.id;
                setStateId(matchingState?.id);
              }
              break;
            default:
              break;
          }
        });

        setFormData({
          ...formData,
          ...updatedFormData,
        });
      })
      .catch((error) => {
        console.log(error);
        setAddressSuggestions([]);
      });
  };

  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setAddressSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef, suggestionsRef]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true); // Disable the button
    if (!data || data.length <= 0) {
      f7.toast
        .create({
          text: "Please select menu items",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    } else if (!formData.rest_id || formData.rest_id.length <= 0) {
      f7.toast
        .create({
          text: "Please select Restaurants",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    } else {
      const formDataWithDate = {
        ...formData,
        event_date: selectedDate, // Include the selected date and time here
        bid_end_date: bidRequestDate, // Include the selected date and time here
        items: JSON.parse(localStorage.getItem("cartItems")) || [],
        state: stateId,
        delivery_type: selectedRadio,
      };
      // return ;
      axios
        .put(API_BASE_URL + "event/id/" + id, formDataWithDate, {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        })
        .then((response) => {
          f7.views.main.router.navigate("/main/", {
            reloadAll: true,
          });
          f7.tab.show("#tab-3");
          f7.toast
            .create({
              text: "Bid has been updated..!",
              position: "top",
              cssClass: "bg-color-teal",
              closeTimeout: 3000,
            })
            .open();
          localStorage.removeItem("cartItems");
        })
        .catch((error) =>
          f7.toast
            .create({
              text: "Event date not selected, error encounter..!",
              position: "top",
              cssClass: "bg-color-red",
              closeTimeout: 3000,
            })
            .open()
        )
        .finally(() => {
          setIsSubmitting(false); // Re-enable the button after registration attempt
        });
      // f7.views.main.router.back({ force: true });
      // f7.tab.show('#tab-3');
    }
  };

  const currentDate = new Date().toISOString().slice(0, 16);

  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const response = await fetch(API_BASE_URL + `menu/?search=${searchTerm}` , {
    //       method: 'GET', // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
    //       headers: {
    //         'Authorization': 'Basic ' + API_AUTH
    //       }
    //     });
    //     const data = await response.json();
    //     // console.log(data);
    //     setSuggestions(data);
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   }
    // };
  }, [searchTerm]);

  const handleMenuChange = (event) => {
    const value = event.target.value;
    setSuggestions([]);
    setSearchTerm(value);
    if (value.length > 0) {
      axios
        .get(API_BASE_URL + `menu/?search=${value}`, {
          // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
          params: {
            menu_type_food: menuTypeId,
          },
        })
        .then((response) => setSuggestions(response.data))
        .catch((error) => {
          console.log(error);
          setSuggestions([]);
        });
    } else {
      setSuggestions([]);
    }
    // setSearchTerm(event.target.value);
  };

  const handleItemClick = (item) => {
    setSuggestions("");
    setSearchTerm(item);
    setSuggestions("");
  };

  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 2);

  const minBidDate = new Date();
  minBidDate.setDate(minBidDate.getDate() + 2);

  const maxDate = new Date(selectedDate);
  maxDate.setDate(maxDate.getDate() - 2);

  const fetchDeliverTypeData = async () => {
    if (selectedRadio === "2") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        add_lin_1: undefined,
        add_lin_2: undefined,
        city: undefined,
        state: undefined,
        zip_code: undefined,
        event_note: undefined,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...addressInfo,
      }));
    }
  };

  useEffect(() => {
    fetchDeliverTypeData();
  }, [selectedRadio]);
  return (
    <Page className="bg-white">
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/>             */}
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Request Bid</h2>
              </div>
            </div>
          </header>
          <section className="profile-form mt-3">
            <div className="custom-container p-0">
              <div class="title">
                <h3 class="mt-2">Edit Event</h3>
              </div>
              <form
                className="auth-form address-form mt-3"
                onSubmit={handleSubmit}
              >
                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Name of the Event
                  </label>
                  <div className="form-input mb-4">
                    <Input
                      type="text"
                      className="form-control"
                      required
                      validate
                      pattern=".{3,}"
                      errorMessage="Please enter name of the event."
                      placeholder="Name of the Event"
                      name="event_name"
                      value={formData.event_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Event Date and time
                  </label>
                  <div className="form-input mb-4">
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      showTimeSelect
                      timeFormat="h:mm aa"
                      timeIntervals={15}
                      dateFormat="MM-dd-yyyy h:mm aa"
                      placeholderText="Select event date and time"
                      className="form-control col-md-12"
                      minDate={minDate}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Bid Request Date
                  </label>
                  <div className="form-input mb-4">
                    <DatePicker
                      selected={bidRequestDate}
                      onChange={(date) => setBidRequestDate(date)}
                      showTimeSelect
                      timeFormat="h:mm aa"
                      timeIntervals={15}
                      dateFormat="MM-dd-yyyy h:mm aa"
                      placeholderText="Select bid request date and time"
                      className="form-control col-md-12"
                      minDate={minBidDate}
                      maxDate={maxDate}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="form-group" style={{ width: "49%" }}>
                    <label className="form-label fw-semibold">
                      No of Adults
                    </label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        required
                        validate
                        pattern="[0-9\s]{1,4}"
                        errorMessage="Please enter no of adults."
                        className="form-control"
                        placeholder="No of Adults"
                        name="event_adult_size"
                        value={formData.event_adult_size}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group" style={{ width: "49%" }}>
                    <label className="form-label fw-semibold">No of Kids</label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        validate
                        pattern="[0-9\s]{1,4}"
                        errorMessage="Please enter no of kids."
                        className="form-control"
                        placeholder="No of Kids"
                        name="event_kids_size"
                        value={formData.event_kids_size}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <List style={{ marginTop: "10px" }}>
                    {/* <label className="form-label fw-semibold">
                      Deliver type
                    </label> */}
                    <ListItem
                      radio
                      value="1"
                      name="demo-radio"
                      title="Delivery"
                      checked={selectedRadio == "1"}
                      onChange={() => handleRadioChange("1")}
                    ></ListItem>
                    <ListItem
                      radio
                      value="2"
                      name="demo-radio"
                      title="Pickup"
                      checked={selectedRadio == "2"}
                      onChange={() => handleRadioChange("2")}
                    ></ListItem>
                  </List>
                </div>
                {selectedRadio !== "2" && (
                  <>
                    <h3 className="mb-3">Event Address</h3>
                    <div className="form-group">
                      <label className="form-label fw-semibold">Address</label>

                      <div className="form-input mb-2">
                        <input
                          ref={inputRef}
                          type="text"
                          // required
                          // validate
                          // pattern=".{5,}"
                          errorMessage="Please enter event address."
                          className="form-control"
                          placeholder="Event Address"
                          name="add_lin_1"
                          value={formData.add_lin_1}
                          // value={addressSearchTerm}
                          autoComplete="off"
                          onChange={handleAddressChange}
                        />
                      </div>
                      <div
                        className="form-input mb-4"
                        style={{ width: "100%" }}
                      >
                        {addressSuggestions.length > 0 &&
                        formData.add_lin_1 !== "" ? (
                          <ul
                            ref={suggestionsRef}
                            className="auto-complete-list"
                            style={{
                              width: "93%",
                              zIndex: 99,
                              minHeight: "auto",
                              maxHeight: "250px",
                              backgroundColor: "white",
                              overflow: "scroll",
                              overflowX: "hidden",
                            }}
                          >
                            {addressSuggestions.map((item) => (
                              <li
                                key={item.id}
                                onClick={() => {
                                  handleAddressItemClick(item);
                                  // setFormData({
                                  //   ...formData,
                                  //   add_lin_1: item.formatted_address,
                                  // });
                                }}
                                style={{ border: "1px solid #E5E7EB" }}
                              >
                                {item.description}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">Address</label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          errorMessage="Please enter event second address."
                          className="form-control"
                          placeholder="Event Address"
                          name="add_lin_2"
                          value={formData.add_lin_2}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">City</label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          // required
                          // validate
                          // pattern="[a-zA-Z ]{2,}"
                          errorMessage="Please enter city."
                          className="form-control"
                          placeholder="City"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">State</label>
                      <div className="form-input mb-4">
                        <select
                          className="form-select form-control"
                          // required
                          // validate
                          errorMessage="Please select State"
                          name="state"
                          value={stateId}
                          onChange={(e) => setStateId(e.target.value)}
                        >
                          <option value="" selected>
                            Select State
                          </option>
                          {citydata.map((item) => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">Zip Code</label>
                      <div className="form-input mb-4">
                        <Input
                          type="tel"
                          className="form-control"
                          // required
                          // validate
                          errorMessage="Please enter zip code"
                          // pattern="[0-9]{5}"
                          placeholder="Enter Zip Code"
                          name="zip_code"
                          value={formData.zip_code}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label fw-semibold">
                        Additional Instructions
                      </label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          validate
                          // pattern=".{5,}"
                          errorMessage="Please enter event note."
                          className="form-control"
                          placeholder="Enter Additional Instructions"
                          name="event_note"
                          value={formData.event_note}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div class="title">
                  <h3 class="mt-2">Restaurant Details</h3>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">
                    Cuisine Type{" "}
                  </label>
                  <div className="form-input mb-4">
                    <select
                      className="form-select form-control"
                      value={cuisineType}
                      onChange={(e) =>
                        setCuisineType(
                          [].slice
                            .call(e.target.selectedOptions)
                            .map((item) => item.value)
                        )
                      }
                      multiple
                    >
                      {cuisine.map((item, index) => (
                        <option value={item.id}>{item.cuisine_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="auth-form address-form mt-0 mb-0"></div>
                <div className="form-group">
                  {/* <label className="form-label fw-semibold">Select Restaurant</label> */}
                  {/* <div className="form-input mb-4"><Input type="text" required validate pattern=".{5,}" errorMessage="Please enter event note." className="form-control" placeholder="Event Note" name="event_note" value={formData.event_note} onChange={handleChange}/></div> */}
                  <ListItem
                    style={{ width: "100%" }}
                    className="text-bg-success btn mt-0"
                    required
                    validate
                    errorMessage="Please select Restaurant"
                    title={`+ Select Restaurant (${edit_rest.length} selected)`}
                    smartSelect
                    smartSelectParams={{
                      openIn: "popup",
                      searchbar: true,
                      searchbarPlaceholder: "Search Restaurant",
                    }}
                  >
                    {/* {restdata.length > 0 && ( */}

                    {/* onChange={e => setMenuType([].slice.call(e.target.selectedOptions).map(item => item.value))} */}
                    {console.log(edit_rest)}
                    <select
                      name="rest_id"
                      multiple
                      value={edit_rest}
                      onChange={handleSelectChange}
                      className="form-control text-2 "
                    >
                      {restdata.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.rest_name}
                        </option>
                      ))}
                    </select>
                    {/* )} */}
                  </ListItem>
                </div>
                {/* formData?.rest_id?.length  */}
                {edit_rest?.length > 0 && (
                  <div class="title">
                    <h3 class="mt-0">Menu Details</h3>
                    <a href="#">
                      <Button
                        fill
                        small
                        className="text-white btn-success filter-button mt-1 text-1"
                        popupOpen=".demo-popup"
                      >
                        {" "}
                        Add Menu{" "}
                      </Button>
                    </a>
                  </div>
                )}
                <div className="auth-form address-form mt-0 mb-0"></div>
                <table className="table table-striped table-sm text-2 mt-0">
                  <tbody>
                    {data.map((item, index) => (
                      <tr className="align-middle" key={index}>
                        <td width={"10%"} className="text-center">
                          {index + 1}.{" "}
                        </td>
                        <td>
                          <h5 className="dark-text fw-bold mb-1">
                            {item.menu_name}
                          </h5>
                          {/* {item.note} */}
                        </td>
                        <td width={"30%"} className="text-center text-md-end">
                          <a
                            href="#"
                            className="btn btn-xs btn-danger order mt-2 p-1 text-3 w-100"
                            role="button"
                            onClick={() => handleDelete(index)}
                          >
                            {" "}
                            &nbsp; Delete &nbsp;{" "}
                          </a>
                        </td>
                      </tr>
                    ))}
                    {/* <tr className='table-success border p-2'><th colSpan={2} className='mt-0'><h4 className='text-end mt-2 fw-bold color-green'>Total Number of menu: </h4></th><th><h4 className='text-end mt-2 fw-bold color-green'>{data.length}</h4></th></tr> */}
                  </tbody>
                </table>
                <Button
                  type="submit"
                  className="btn theme-btn w-100"
                  large
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update Bid"}
                </Button>
                {/* <Button className="btn theme-btn w-100" large type="submit">Update Bid</Button>       */}
              </form>
            </div>
          </section>

          <section className="section-b-space pt-2">
            <div className="custom-container"></div>
          </section>
          <Popup className="demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link />
                        <h2>Add Menu</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  {/* <div className="modal-title text-center">
                    <h2 className="fw-bold1">Add Menu</h2>
                    <Link className="btn-close" popupClose/>
                  </div> */}
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form
                        id="formAddCart"
                        ref={formRef}
                        onSubmit={handleAddToCart}
                        className="auth-form profile-form"
                      >
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Type
                          </label>
                          <div className="form-input mb-4">
                            <select
                              className="form-select form-control"
                              required
                              validate
                              errorMessage="Please select State"
                              name="menu_type"
                              value={menuTypeId}
                              onChange={(e) => setMenuTypeId(e.target.value)}
                            >
                              <option value="0" selected>
                                Select Menu Type
                              </option>
                              {menuType.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Select Menu
                          </label>
                          <div className="form-input mb-4">
                            <input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              required
                              validate
                              value={searchTerm}
                              name="menu_name"
                              autoComplete="off"
                              // value={product.menu_name}
                              onChange={handleMenuChange}
                              placeholder="Type to search..."
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="form-input mb-4">
                            {suggestions.length > 0 ? (
                              <ul className="auto-complete-list">
                                {suggestions.map((item) => (
                                  <li
                                    key={item.id}
                                    onClick={() =>
                                      handleItemClick(item.menu_item_name)
                                    }
                                  >
                                    {item.menu_item_name}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              ""
                            )}
                            {/* <Input type="text" className="form-control" required validate pattern="^[A-Za-z0-9 ]+$" placeholder="Enter Menu Name" name="menu_name" value={product.menu_name} onChange={handleInputChange}/> */}
                            {filteredOptions.length > 0 && (
                              <ul className="auto-complete-list">
                                {filteredOptions.map((option, index) => (
                                  <li
                                    key={index}
                                    onClick={() => handleOptionClick(option)}
                                  >
                                    {option}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Additional Instructions
                          </label>
                          <div className="form-input mb-4">
                            <input
                              type="text"
                              id="inputNote"
                              className="form-control"
                              name="note"
                              value={product.note}
                              onChange={handleInputChange}
                              placeholder="Enter Additional Instructions"
                            />
                          </div>
                        </div>
                        <Button
                          className="btn btn-success w-100 text-capitalize mt-0"
                          large
                          type="submit"
                        >
                          Add Menu
                        </Button>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
        </div>
      </div>
    </Page>
  );
};

export default EditEventPage;
